module.exports = __webpack_public_path__ + "static/media/social-instagram.a57cb906.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-instagram.svg
// module id = 158
// module chunks = 0